import { Button, Card, Modal } from '@playerbase/ui';

type ReleaseNotesModalProps = {
  open: boolean;
  buildLabel: string;
  notes: string;
  onClose: () => void;
};

export function ReleaseNotesModal({
  open,
  buildLabel,
  notes,
  onClose,
}: ReleaseNotesModalProps): JSX.Element {
  return (
    <Modal open={open} onClose={onClose} labelledById="release-notes-title">
      <Card>
        <Card.Header>
          <Card.Title id="release-notes-title">Release notes — {buildLabel}</Card.Title>
        </Card.Header>
        <Card.Content>
          {/* Preserve newlines from however the dev typed the notes — most
              changelog conventions use line breaks for separators. */}
          <pre className="whitespace-pre-wrap font-sans text-sm text-text leading-relaxed">
            {notes}
          </pre>
        </Card.Content>
        <Card.Footer className="justify-end">
          <Button variant="ghost" size="md" onClick={onClose}>
            Close
          </Button>
        </Card.Footer>
      </Card>
    </Modal>
  );
}
